import React, { lazy, useContext, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ProtectedRoute from "./Authorization/ProtectedRoute";

// css for making phone input "phone" dark mode compat
import "../src/assets/css/custom.css";
import { AxiosInterceptor } from "./config/axiosInstance";
import ResetPassword from "./pages/ResetPassword";
import { WindmillContext } from "@windmill/react-ui";
import Layout_SEO from "./containers/Layout_SEO";

const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const CreateAccount = lazy(() => import("./pages/CreateAccount"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));

function App() {
  const { mode, toggleMode } = useContext(WindmillContext);

  const updateFavicon = (theme) => {
    const favicon = document.getElementById("favicon");
    favicon.href = theme === "dark" ? "/FAVICON_dark.png" : "/FAVICON_light.png";
  };

  useEffect(() => {
    updateFavicon(mode);
  }, [mode]);

  return (
    <>
      <Router>
        <ToastContainer />
        <AxiosInterceptor />
        <AccessibleNavigationAnnouncer />
        <Switch>
          <Redirect exact from="/" to="/login" />
          <Route path="/login" component={Login} />
          
          <ProtectedRoute path="/app" component={Layout} />
          <Layout_SEO first={true}>
            {/* <Route path="/create-account" component={CreateAccount} /> */}
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password/:slug" component={ResetPassword} />
            {/* Place new routes over this */}
          </Layout_SEO>
          <Redirect exact from="*" to="/404" />
          {/* If you have an index page, you can remothis Redirect */}s
        </Switch>
      </Router>
    </>
  );
}

export default App;
